import React, { useState, useEffect, useContext } from "react";
import Layout from "../layouts/Layout";
import { AuthContext } from '../AuthContext';
import { firestore, doc, getDoc } from "../firebase-config";
import ContentEditor from "../components/ContentEditor";
import "../styles/Resources.css";

const Resources = () => {
  const { loggedInUser } = useContext(AuthContext);
  const isAdmin = loggedInUser?.role === 'Admin';
  const [title, setTitle] = useState(''); //Use empty string as default state (while loading)
  const [content, setContent] = useState('<p></p>'); //Use empty string as default state (while loading)
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const pageRef = doc(firestore, 'pageContent', 'resources');
        const pageSnap = await getDoc(pageRef);
        if (pageSnap.exists()) {
          const data = pageSnap.data();
          setTitle(data.title || ''); //Use empty string as default state (while loading)
          setContent(data.content || '<p></p>'); //Use empty string as default state (while loading)
        }
      } catch (error) {
        console.error('Error fetching content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const handleSave = (newTitle, newContent) => {
    setTitle(newTitle);
    setContent(newContent);
  };

  // if (loading) return <p>Loading...</p>;

  return (
    <Layout featureType="resources">
      {isAdmin ? (
        <ContentEditor pageId="resources" initialTitle={title} initialContent={content} onSave={handleSave} />
      ) : (
        <>
          <h2>{title}</h2>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </>
      )}
    </Layout>
  );
};

export default Resources;